'use client';
import { isBrowser } from '../platform/isBrowser.js';

/**
 * Функция для безопасного использования window в любом контексте исполнения.
 * @param fallback fallback-объект, если `window` не существует в текущем контексте
 * @returns fallback-объект для SSR контекста, `window` для браузера.
 */ const windowSafe = (fallback)=>isBrowser ? window : fallback;

export { windowSafe };
//# sourceMappingURL=windowSafe.js.map
